(() => {
  if (window.foFooterMenuBound) return;
  window.foFooterMenuBound = true;
  const mobile = window.matchMedia('(max-width:699px)');
  const setMode = details => {
    if (mobile.matches && details.contains(document.activeElement)) details.querySelector('summary')?.focus();
    details.open = !mobile.matches;
    const summary = details.querySelector('summary');
    if (summary) {
      summary.tabIndex = mobile.matches ? 0 : -1;
      if (mobile.matches) summary.removeAttribute('aria-disabled');
      else summary.setAttribute('aria-disabled', 'true');
    }
  };
  const initialize = (root = document) => root.querySelectorAll('[data-fo-footer-accordion]').forEach(details => {
    if (details.dataset.footerBound) return;
    details.dataset.footerBound = 'true';
    setMode(details);
    details.querySelector('summary')?.addEventListener('click', event => {
      if (!mobile.matches) event.preventDefault();
    });
    details.addEventListener('toggle', () => {
      if (!mobile.matches && !details.open) details.open = true;
    });
  });
  initialize();
  mobile.addEventListener('change', () => document.querySelectorAll('[data-fo-footer-accordion]').forEach(setMode));
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
